import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter } from "react-router-dom";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HyperlinkProvider } from './contexts/HyperlinkProvider';

const location = window.location.pathname.toLowerCase();
console.log(location);
const baseName = process.env.REACT_APP_BASENAME;

let basePath = baseName;
if (baseName === "/february2024") {
  basePath = basePath + "/";
}

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      {location === baseName || location === "/february2024/" ? <HyperlinkProvider>
          <App />
        </HyperlinkProvider> : ""}
      {location !== baseName && location !== "/february2024/" ? (
        <HyperlinkProvider>
          <App />
        </HyperlinkProvider>
         ) : (
        ""
      )}
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
